import { ApiUser, IUser } from "@/types";

export const mockUser: IUser = {
  createdAt: new Date(),
  email: 'john.doe@example.com',
  imageUrl: 'https://randomuser.me/api/portraits/men/75.jpg',
  name: 'Doe, John [JANUS NON-J&J]',
  role: 'dm',
  updatedAt: new Date(),
  uuid: 'user123',
  username: 'john.doe',
};

// Generate a random number of additional users (8-15 users total)
const generateMockUsers = (): IUser[] => {
  const firstNames = [
    'Sarah', 'Michael', 'Jessica', 'David', 'Emily', 'Chris', 'Amanda', 'Ryan',
    'Lisa', 'Kevin', 'Jennifer', 'Mark', 'Ashley', 'Brian', 'Michelle', 'Daniel',
    'Lauren', 'James', 'Rachel', 'Andrew', 'Nicole', 'Joseph', 'Stephanie', 'Matthew'
  ];
  
  const lastNames = [
    'Johnson', 'Williams', 'Brown', 'Jones', 'Garcia', 'Miller', 'Davis', 'Rodriguez',
    'Martinez', 'Hernandez', 'Lopez', 'Gonzalez', 'Wilson', 'Anderson', 'Thomas', 'Taylor',
    'Moore', 'Jackson', 'Martin', 'Lee', 'Perez', 'Thompson', 'White', 'Harris'
  ];
  
  const departments = [
    'Sales - North America', 'Sales - Europe', 'Sales - Asia Pacific', 
    'Marketing', 'Customer Success', 'Business Development', 'Regional Sales'
  ];
  
  const roles: ('rep' | 'dm')[] = ['rep', 'dm'];
  
  const certifications = [
    'Advanced Sales Certification', 'Customer Relations Expert', 'Product Specialist',
    'Leadership Development', 'Digital Marketing Certified', 'Negotiation Mastery'
  ];

  // Random number of users between 8-15
  const numberOfUsers = Math.floor(Math.random() * 8) + 8;
  const users: IUser[] = [mockUser]; // Keep the original mock user
  
  for (let i = 1; i < numberOfUsers; i++) {
    const firstName = firstNames[Math.floor(Math.random() * firstNames.length)];
    const lastName = lastNames[Math.floor(Math.random() * lastNames.length)];
    const name = `${lastName}, ${firstName} [JANUS NON-J&J]`;
    const email = `${firstName.toLowerCase()}.${lastName.toLowerCase()}@jnj.com`;
    const role = roles[Math.floor(Math.random() * roles.length)];
    const department = departments[Math.floor(Math.random() * departments.length)];
    const username = `${firstName.toLowerCase()}.${lastName.toLowerCase()}`;

    // Random certifications (0-3 per user)
    const userCertifications: string[] = [];
    const certCount = Math.floor(Math.random() * 4);
    for (let j = 0; j < certCount; j++) {
      const cert = certifications[Math.floor(Math.random() * certifications.length)];
      if (!userCertifications.includes(cert)) {
        userCertifications.push(cert);
      }
    }
    
    // Random dates within the last 2 years
    const createdDate = new Date();
    createdDate.setDate(createdDate.getDate() - Math.floor(Math.random() * 730));
    
    const updatedDate = new Date(createdDate);
    updatedDate.setDate(updatedDate.getDate() + Math.floor(Math.random() * 30));
    
    // Random avatar (using different portrait numbers)
    const avatarNumber = Math.floor(Math.random() * 100);
    const gender = Math.random() > 0.5 ? 'men' : 'women';
    const imageUrl = `https://randomuser.me/api/portraits/${gender}/${avatarNumber}.jpg`;
    
    users.push({
      uuid: `user_${i + 1}`,
      name,
      email,
      role,
      department,
      certifications: userCertifications.length > 0 ? userCertifications : undefined,
      imageUrl,
      createdAt: createdDate,
      updatedAt: updatedDate,
      username,
    });
  }
  
  return users;
};

export const mockUsers: IUser[] = generateMockUsers();

export const mockApiUser: ApiUser = {
  id: 'user123',
  email: 'john.doe@example.com',
  name: 'Doe, John [Mock API]',
  full_name: 'Doe, John [Mock API]',
  role: 'dm',
  sso_subject: 'sso_john_doe',
  manager_id: 'manager_1',
  status: 'active',
  created_at: new Date().toISOString(),
  updated_at: new Date().toISOString(),
};

export const mockApiUsers: ApiUser[] = mockUsers.map((user) => ({
  id: user.uuid,
  name: user.name,
  full_name: user.name,
  email: user.email || '',
  role: user.role,
  sso_subject: `sso_${user.username}`,
  manager_id: null,
  status: 'active',
  created_at: user.createdAt.toISOString(),
  updated_at: user.updatedAt.toISOString(),
}));